import { LabelClass } from './scheming-package.model';

export class ExtrasModel {
    value_label: any;
    value_type: string;
    value: any;
    field_label: any;
    visible: boolean;
}
